module.exports = __webpack_public_path__ + "assets/img/btn-view-8feeae35.png";